import { render, staticRenderFns } from "./previewSdk.vue?vue&type=template&id=6c04cc93&"
import script from "./previewSdk.vue?vue&type=script&lang=js&"
export * from "./previewSdk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports